document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('customerForm');
    const submitButton = document.getElementById('submit-button');
    const canvas = document.getElementById('signaturePad');
    let signaturePad;

    // Initialize SignaturePad
    function initializeSignaturePad() {
        if (!canvas) return;
        
        const container = canvas.parentElement;
        const containerStyles = window.getComputedStyle(container);
        const containerWidth = container.clientWidth - 
            (parseFloat(containerStyles.paddingLeft) + parseFloat(containerStyles.paddingRight)) - 2;
        const containerHeight = container.clientHeight - 
            (parseFloat(containerStyles.paddingTop) + parseFloat(containerStyles.paddingBottom)) - 
            document.querySelector('.clear-signature').offsetHeight - 16;
        
        canvas.style.width = containerWidth + 'px';
        canvas.style.height = containerHeight + 'px';
        
        const devicePixelRatio = window.devicePixelRatio || 1;
        canvas.width = containerWidth * devicePixelRatio;
        canvas.height = containerHeight * devicePixelRatio;
        
        const context = canvas.getContext('2d');
        context.scale(devicePixelRatio, devicePixelRatio);
        
        signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)',
            penColor: 'rgb(0, 0, 0)'
        });
    }

    // Handle window resize for signature pad
    function resizeCanvas() {
        if (!signaturePad) return;
        const signatureData = signaturePad.toData();
        initializeSignaturePad();
        if (signatureData) {
            signaturePad.fromData(signatureData);
        }
    }

    // Initialize signature pad if it exists
    if (canvas) {
        initializeSignaturePad();
        window.addEventListener('resize', resizeCanvas);
        
        document.querySelector('.clear-signature')?.addEventListener('click', () => {
            signaturePad?.clear();
            validateForm();
        });
    }

    // Insurance Selection
    const insuranceButtons = document.querySelectorAll('.insurance-button');
    const insuranceInput = document.getElementById('insurancetype');
    const privateInsuranceModal = document.getElementById('privateInsuranceModal');

    if (insuranceButtons && insuranceInput) {
        insuranceButtons.forEach(button => {
            button.addEventListener('click', function() {
                insuranceButtons.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                insuranceInput.value = this.dataset.value;
                
                // Show modal if "privat versichert" is selected
                if (this.dataset.value === 'privat') {
                    showPrivateInsuranceInfo();
                }
                
                validateForm();
            });
        });
    }

    // Insurance Number Info Modal Functions
    window.showInsuranceNumberInfo = function() {
        const modal = document.getElementById('insuranceNumberModal');
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }

    window.hideInsuranceNumberInfo = function() {
        const modal = document.getElementById('insuranceNumberModal');
        modal.style.display = 'none';
        document.body.style.overflow = '';
    }

    // Private Insurance Modal Functions
    window.showPrivateInsuranceInfo = function() {
        privateInsuranceModal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }

    window.hidePrivateInsuranceInfo = function() {
        privateInsuranceModal.style.display = 'none';
        document.body.style.overflow = '';
    }

    // Care Level Selection
    const careLevelButtons = document.querySelectorAll('.care-level-button');
    const careLevelInput = document.getElementById('careLevel');
    const careLevelWarning = document.getElementById('careLevelWarning');

    if (careLevelButtons && careLevelInput) {
        careLevelButtons.forEach(button => {
            button.addEventListener('click', function() {
                careLevelButtons.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                careLevelInput.value = this.dataset.value;
                
                if (this.dataset.value === '0' && careLevelWarning) {
                    careLevelWarning.style.display = 'block';
                } else if (careLevelWarning) {
                    careLevelWarning.style.display = 'none';
                }
                
                validateForm();
            });
        });
    }

    // Delivery Rhythm Selection
    const rhythmButtons = document.querySelectorAll('.rhythm-button');
    const rhythmInput = document.getElementById('deliveryrhythm');

    if (rhythmButtons && rhythmInput) {
        rhythmButtons.forEach(button => {
            button.addEventListener('click', function() {
                rhythmButtons.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                rhythmInput.value = this.dataset.value;
                validateForm();
            });
        });
    }

    // Consultation Selection
    const consultationButtons = document.querySelectorAll('.consultation-button');
    const consultationInput = document.getElementById('consultation');
    const reasonContainer = document.getElementById('consultationReasonContainer');
    const reasonTextarea = document.getElementById('consultationReason');

    if (consultationButtons && consultationInput) {
        consultationButtons.forEach(button => {
            button.addEventListener('click', function() {
                consultationButtons.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                consultationInput.value = this.dataset.value;
                
                // Show/hide reason textarea based on selection
                if (this.dataset.value === 'no') {
                    reasonContainer.style.display = 'block';
                    reasonTextarea.required = true;
                } else {
                    reasonContainer.style.display = 'none';
                    reasonTextarea.required = false;
                    reasonTextarea.value = '';
                }
                
                validateForm();
            });
        });
    }

    // Phone number formatting
    const phoneInputs = document.querySelectorAll('input[type="tel"]');
    phoneInputs.forEach(input => {
        input.addEventListener('blur', function() {
            const value = this.value.trim();
            if (value.startsWith('0')) {
                this.value = '+49' + value.substring(1);
            }
        });
    });

    // Load selected products for preview
    const selectedProducts = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
    const productPreview = document.getElementById('productPreview');
    
    if (productPreview && selectedProducts.length > 0) {
        productPreview.innerHTML = selectedProducts.map(product => `
            <div class="product-preview-item">
                <span class="product-quantity">${product.quantity} x</span>
                <img src="${product.image}" alt="${product.title}" class="product-image">
                <div class="product-info">
                    <h4 class="product-title">${product.title}</h4>
                    <p class="product-description">${product.description}</p>
                </div>
            </div>
        `).join('');
    }

    // Form Validation
    function validateForm() {
        if (!form) return;
        
        const requiredFields = form.querySelectorAll('[required]');
        let isValid = true;

        requiredFields.forEach(field => {
            if (!field.value.trim()) {
                isValid = false;
                field.classList.add('error');
            } else {
                field.classList.remove('error');
            }
        });

        // Check required selections
        if (!insuranceInput.value) {
            isValid = false;
        }

        if (!careLevelInput.value || careLevelInput.value === '0') {
            isValid = false;
        }

        if (!rhythmInput.value) {
            isValid = false;
        }

        if (!consultationInput.value) {
            isValid = false;
        }

        // Check reason textarea if "no consultation" is selected
        if (consultationInput.value === 'no' && !reasonTextarea.value.trim()) {
            isValid = false;
        }

        // Check signature
        if (signaturePad?.isEmpty()) {
            isValid = false;
        }

        // Check checkboxes
        const privacyCheckbox = document.getElementById('privacy');
        const termsCheckbox = document.getElementById('terms');
        if (!privacyCheckbox?.checked || !termsCheckbox?.checked) {
            isValid = false;
        }

        if (submitButton) {
            submitButton.disabled = !isValid;
            submitButton.classList.toggle('active', isValid);
        }

        return isValid;
    }

    // Form Submission
    if (form) {
        form.addEventListener('submit', async function(e) {
            e.preventDefault();
            if (submitButton.disabled) return;

            const formData = new FormData(this);
            const customerData = Object.fromEntries(formData);
            
            if (signaturePad) {
                 const res = await fetch("https://caredirekt24--development.gadget.app/upload", {
                                      method: "POST",
                                      headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                      },
                                      body: JSON.stringify({
                                        signatureUrl: signaturePad.toDataURL()
                                      }),
                                    });
                const uploadRes = await res.json();
                customerData.signature = uploadRes.resourceUrl;
                sessionStorage.setItem('signature', uploadRes.resourceUrl);
                // customerData.signature = signaturePad.toDataURL();
                // sessionStorage.setItem('signature', signaturePad.toDataURL());
            }
            
            sessionStorage.setItem('customerData', JSON.stringify(customerData));
            window.location.href = '/pages/pflegebox-process';
        });

        // Event listeners for validation
        form.addEventListener('input', validateForm);
        form.addEventListener('change', validateForm);
        if (signaturePad) {
            canvas.addEventListener('mouseup', validateForm);
            canvas.addEventListener('touchend', validateForm);
        }

        // Initial validation
        validateForm();
    }

    // Close modals when clicking outside
    window.onclick = function(event) {
        if (event.target === privateInsuranceModal) {
            hidePrivateInsuranceInfo();
        }
        if (event.target === document.getElementById('insuranceNumberModal')) {
            hideInsuranceNumberInfo();
        }
    }

    // Close modals with ESC key
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            if (privateInsuranceModal.style.display === 'block') {
                hidePrivateInsuranceInfo();
            }
            if (document.getElementById('insuranceNumberModal').style.display === 'block') {
                hideInsuranceNumberInfo();
            }
        }
    });
});